import { useState } from 'react';
import { useIntl } from 'react-intl';
import PropTypes from 'prop-types';

import { IconButton, Callout } from '@folio/stripes/components';

import { SmartHelpModal } from './components';

const propTypes = {
  calloutRef: PropTypes.oneOfType([PropTypes.func, PropTypes.object]),
  renderCustomTrigger: PropTypes.func,
  onResponse: PropTypes.func,
};

const defaultProps = {
  calloutRef: null,
  renderCustomTrigger: null,
  onResponse: () => {},
};

const SmartHelp = ({ calloutRef, renderCustomTrigger, onResponse }) => {
  const intl = useIntl();
  const [isOpen, setIsOpen] = useState(false);

  const openModal = () => {
    setIsOpen(true);
  };

  const closeModal = () => {
    setIsOpen(false);
  };

  const renderDefaultTrigger = () => {
    return (
      <IconButton
        icon="question"
        aria-haspopup="true"
        title={intl.formatMessage({ id: 'ui-plugin-smart-help.openSmartHelp' })}
        ariaLabel={intl.formatMessage({
          id: 'ui-plugin-smart-help.openSmartHelp',
        })}
        onClick={openModal}
      />
    );
  };

  const handleResponse = (response) => {
    onResponse(response);
  };

  const renderTrigger = () => {
    return renderCustomTrigger
      ? renderCustomTrigger({ onClick: openModal })
      : renderDefaultTrigger();
  };

  return (
    <>
      {renderTrigger()}
      {isOpen && (
        <>
          <SmartHelpModal
            open={isOpen}
            onClose={closeModal}
            onResponse={handleResponse}
          />
          <Callout ref={calloutRef} />
        </>
      )}
    </>
  );
};

SmartHelp.propTypes = propTypes;
SmartHelp.defaultProps = defaultProps;

export default SmartHelp;
